import { memo } from 'react';
import type { FC } from 'react';
import { LINKICON,LINKICON2,LINKICON3 } from './Ftmenu/Ftmenu';
import { Timeline } from "react-twitter-widgets";
import { INFOMATION } from './INFOMATION/INFOMATION';
import classes from './IPhone141.module.scss';
import { INFO,NEWITEM,ITEM,POSTCARD, NEWBOOK } from './Box';
import {Twi,Pic} from './FaTwitter/FaTwitter'
import React from 'react';

interface Props {
  className?: string;
  hide?: {
    vector?: boolean;
    vecter2?: boolean;
  };
}
/* @figmaId 1:2 */
export const IPhone141: FC<Props> = memo(function IPhone141(props = {}) {
  return (
    <div className={`${classes.root}`}>
      <div className={classes.rectangle1}></div>
      <h1 className={classes.h1}>MENUlist</h1>
      <h2 className={classes.h2}>プラーシ　お品書き</h2>

      <INFOMATION />
      <INFO />
      <INFOMATION
        className={classes.h1}
        text={{iNFOMATION: <h1 className={classes.h1}>NEW</h1>,}}
      />
      <NEWBOOK />
      <INFOMATION
        className={classes.h1}
        text={{iNFOMATION: <h1 className={classes.h1}>ITEM</h1>,}}
      />
      <POSTCARD />
      <INFOMATION
        className={classes.h1}
        text={{iNFOMATION: <h1 className={classes.h1}>ITEM</h1>,}}
      />
      <NEWITEM />
      <INFOMATION
        className={classes.h1}
        text={{iNFOMATION: <h1 className={classes.h1}>ITEM</h1>,}}
      />
      <ITEM />
 
      <div className={classes.umekomi}>
      <Timeline
    dataSource={{ sourceType: "profile", screenName: "888morito" }}
    options={{ lang: "ja", width: "550", height: "500" }}
  />
</div>
      <div className={classes.wrap}>
        <div className={classes.textBlock}>
        ※画像右下の星マークはいいねのようなものですが、色がつくだけで今はカウントも記録もできません。遊びに使ってください。</div>
        <div className={classes.textBlock}>
        ※当アプリにショップ機能はありません。無料展示以外は全て外部リンクに接続しています。</div>
      </div>
      <div className={`${classes.wrap} ${classes.flexAround}`}><Twi /><Pic /></div>
      <div className={classes.CopyRight} >Written by nnaw@888morito</div>
      <div className={classes.background}style={{top:"12%",left: "10%"}}>@888morito @888morito @888morito @888morito @888morito</div>
      <div className={classes.background}>@888morito @888morito @888morito @888morito @888morito @888morito @888morito @888morito</div>
      <div className={classes.menu}><div className={classes.flex}>
      <LINKICON /><LINKICON2 /><LINKICON3 /></div>
      </div>
    </div>
  );
});
